
import { useEffect } from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import ArticleTable from '../components/ArticleTable';
import CalBooking from '../components/CalBooking';
import Footer from '../components/Footer';
import DynamicTitle from '../components/DynamicTitle';
import SEOStructuredData from '../components/SEOStructuredData';
import SEOMetaTags from '../components/SEOMetaTags';

export default function Index() {
  useEffect(() => {
    // Handle hash navigation on page load
    const handleHashNavigation = () => {
      const hash = window.location.hash;
      if (hash === '#booking') {
        // Small delay to ensure the component is rendered
        setTimeout(() => {
          const bookingElement = document.getElementById('booking');
          if (bookingElement) {
            bookingElement.scrollIntoView({ 
              behavior: 'smooth',
              block: 'start'
            });
          }
        }, 100);
      }
    };

    // Handle navigation on initial load
    handleHashNavigation();

    // Handle navigation when hash changes
    window.addEventListener('hashchange', handleHashNavigation);

    return () => {
      window.removeEventListener('hashchange', handleHashNavigation);
    };
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-[#0a0a0a] overflow-x-hidden">
      <SEOMetaTags
        title="AI Solopreneur Journey - Tips, Projects & Armenian AI Community"
        description="Follow Aram AI's journey as an AI solopreneur. Learn about AI tools, Armenian AI community, productivity tips, and entrepreneurship insights. Join the Armenian tech revolution."
        keywords="AI solopreneur, Armenian AI, artificial intelligence, entrepreneurship, productivity, tech tutorials, AI tools, Armenian technology, machine learning"
        canonicalUrl="https://tezzarida.io"
        ogType="website"
      />
      <DynamicTitle 
        title="AI Solopreneur Journey - Tips, Projects & Armenian AI Community"
        description="Follow Aram AI's journey as an AI solopreneur. Learn about AI tools, Armenian AI community, productivity tips, and entrepreneurship insights. Join the Armenian tech revolution."
        keywords="AI solopreneur, Armenian AI, artificial intelligence, entrepreneurship, productivity, tech tutorials, AI tools, Armenian technology, machine learning"
        canonicalUrl="https://tezzarida.io"
      />
      <SEOStructuredData 
        type="website"
        title="AI Solopreneur Journey - Tips, Projects & Armenian AI Community"
        description="Follow Aram AI's journey as an AI solopreneur. Learn about AI tools, Armenian AI community, productivity tips, and entrepreneurship insights."
        url="https://tezzarida.io"
      />
      <Header />
      <main className="flex-1 overflow-x-hidden">
        <Hero />
        <div className="container mx-auto px-4" id="articles">
          <ArticleTable />
        </div>
        <CalBooking />
      </main>
      <Footer />
    </div>
  );
}
